export class AlertsDashboardCount {
  alertDayBar: {
    [Key: string]: {
      openAlertCount: number;
      totalAlertCount: number;
    };
  };
  selectedDayCount: {
    [key: string]: {
      activeCount: number;
      totalCount: number;
      openAlertCountAssignedToMe: number;
      totalAlertCountAssignedToMe: number;
    };
  };
  allDayAlerts: {
    openAlertCount: number;
    totalAlertCount: number;
  };
  totalCount: number;
}
